import { DisplaySm, PrimaryButton, SecondaryButton, TertiaryButton, TextMd } from '@545490/karta-web-components';
import { styled } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Box, Dialog, DialogProps, Grid } from '@mui/material';
import { styles } from '../constants/styles';
import { useIsMobileView } from '../hooks';

type Props = DialogProps & {
  handleClose: () => void;
  handleConfirm: () => void;
};

const ButtonStyle = {
  fontWeight: 'bold',
  width: '100%',
  textTransform: 'none',
  marginTop: 16,
};

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-container': {
    '& .MuiDialog-paper': {
      borderRadius: 16,
      maxWidth: 500,
    },
  },
}));

const ScheduleExpiredDialog = (props: Props) => {
  const isMobile = useIsMobileView();
  const { handleClose, handleConfirm, ...rest } = props;

  return (
    <StyledDialog data-testid="leave-modal" aria-labelledby="leave-dialog" {...rest}>
      <Box
        sx={{
          padding: 3,
          display: 'flex',
          flexDirection: 'column',
          background: '#ffffff',
          top: '50%',
          left: '50%',
          maxWidth: '376px',
          minWidth: '100%',
        }}
      >
        <Box display="flex" flexDirection="row" alignItems="center">
          <DisplaySm
            sx={{
              fontFamily: 'Rubik',
              fontSize: 20,
              fontWeight: 700,
              my: 0,
              flex: 1,
            }}
          >
            Schedule Delivery Time Expired
          </DisplaySm>
        </Box>
        <TextMd
          sx={{
            fontFamily: 'Rubik',
          }}
          mt={1}
        >
          We're sorry, but due to the extended checkout process, your scheduled delivery time is now in the past.
        </TextMd>
        <TextMd
          sx={{
            fontFamily: 'Rubik',
          }}
          mt={1}
        >
          Would you like to send your Gift Card now or change the delivery date and time?
        </TextMd>
        <Grid container spacing={2} mt={{ xs: 0, md: 2 }}>
          <Grid item xs={12} md={6}>
            <SecondaryButton
              fullWidth
              variant="outlined"
              style={styles.button({
                ...ButtonStyle,
                marginTop: 0,
                background: '#ffffff',
                borderColor: '#2E2E2E',
                color: '#2E2E2E',
              })}
              onClick={handleClose}
            >
              Change
            </SecondaryButton>
          </Grid>
          <Grid item xs={12} md={6}>
            <PrimaryButton
              fullWidth
              variant="contained"
              style={styles.button({ ...ButtonStyle, marginTop: 0 })}
              onClick={handleConfirm}
              disableElevation
            >
              Send Now
            </PrimaryButton>
          </Grid>
        </Grid>
      </Box>
    </StyledDialog>
  );
};

export default ScheduleExpiredDialog;
